import { FileInfo } from "../file-info"


export class CustomerInfo {
    constructor(
        public LastName: string,
        public FirstName: string,
        public Address1: string,
        public Address2: string,
        public Address3: string,
        public City: string,
        public Province: string,
        public PostalCode: string,
        public DateOfBirth: string,
        public Email: string,
        public MaskCellNumber: string,
        public CellNumber: string,
        public Beneficiary: string,
        public Salutation: string,
        public Nationality: string,
        public Country: string,
        public Region: string,
        public BirthCity: string,
        public TaxId?: string,
        public AccountNumber?: string,
        public ExpiryDate?: string,
        public NationalityValue?: string,
        public CountryValue?: string,
        public BirthPlace?: string,
        public CreditCard?: string,
        public IbanLast4Digits?: string,
        public FormattedAddress?: string,
        public CustomerType?: string,
        public IdentificationNumber?: string,
        public EndorsementReason?: string,
        public CertificateNumber?: string,
        public IdDocuments?: FileInfo[],
        public State?: string
    ) {
        this.CityOfBirth = BirthCity;
    }

    public CityOfBirth: string;

    public getFullName() {
        return this.FirstName + ' ' + this.LastName
    }

    public getFullAddress() {
        return this.Address1 + ' ' + this.City

    }
}
